<template>
  <div class="footer">
    <el-row :gutter="10" style="margin: 0px">
      <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11" :offset="1" style="">
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            padding-top: 30px;
          "
        >
          <img src="../../assets/logo7.png" height="85" width="328" />
          <div style="padding-top: 10px; display: flex">
            <span style="font-size: 16px; font-weight: bold">联系电话：</span>
            <span style="font-size: 16px">024-56865005</span>
            <span style="font-size: 16px; font-weight: bold; padding-left: 20px"
              >地址：</span
            >
            <span style="font-size: 16px"
              >辽宁省抚顺市望花区丹东路西段一号</span
            >
            <span style="font-size: 16px; font-weight: bold; padding-left: 20px"
              >邮编：</span
            >
            <span style="font-size: 16px">113001</span>
          </div>
        </div>
      </el-col>
      <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            padding-top: 40px;
            border-left: 1px solid #666666;
          "
        >
          <img src="../../assets/mlogo01.png" height="55" width="246" />
          <div style="padding-top: 10px; display: flex">
            <span style="font-size: 14px; font-weight: bold"
              >山东图灵锶软件有限公司技术支持</span
            >
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
.footer {
  background-color: #99a9bf;
  height: 160px;
  position: relative;
  bottom: 0;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>
